import React from 'react';
import { Box } from '@material-ui/core';
import KeyboardArrowDownOutlined from '@material-ui/icons/KeyboardArrowDownOutlined';
import { colorPalette } from '../../colorPalette';
import { useStyles, CustomAccordion, CustomAccordionDetails, CustomSummary } from './Accordion.style';
export const AccordionMui = (props) => {
    const { title, subTitle, children, icon, summaryColor, detailsColor, isLite = false } = props;
    const s = useStyles(props);
    return (React.createElement(CustomAccordion, { className: isLite ? s.customAccordionLite : s.customAccordionwithoutBorder },
        React.createElement(CustomSummary, { summaryColor: summaryColor, expandIcon: React.createElement(KeyboardArrowDownOutlined, { htmlColor: colorPalette.gray700, style: { fontSize: '18px' } }) },
            React.createElement(React.Fragment, null,
                icon ? (React.createElement(Box, { className: s.icon }, icon)) : null,
                React.createElement(Box, null,
                    React.createElement("p", { className: s.title }, title),
                    subTitle ? (React.createElement("p", { className: s.subTitle, dangerouslySetInnerHTML: { __html: subTitle } })) : null))),
        React.createElement(CustomAccordionDetails, { detailsColor: detailsColor, className: isLite ? s.detailsLite : s.details },
            React.createElement(Box, { className: s.detailsContent }, children))));
};
